import './application';
import './top';

/* 条件によるjavascriptのインポートを設定する */

if (document.getElementById('profile-close-remind-popup-config')) {
  import('./profile_close_remind_popup');
}

if (document.getElementById('is-not-signed-on-index-config')) {
  import('./is_not_signed_on_index');
}

if (document.getElementById('first-login-tutorial-on-index-config')) {
  import('./first_login_tutorial_on_index');
}